module.exports = __webpack_public_path__ + "static/media/home.e0b34292.jpg";